export default class Utilites {
    static parseProps(DOMNode) {
        const attributes = {};
        const needle = [
            "data-specialization",
            "data-clinic",
            "data-doctor",
            "data-service",
            "data-branch",
            "data-tag",
        ];

        let isValid = true;
        for (let i = 0; i < DOMNode.attributes.length; i++) {
            const attribute = DOMNode.attributes[i];

            if (needle.indexOf(attribute.name) !== -1) {
                const attributeNameSplited = attribute.name.split("-");
                let value;
                if (attribute.name !== "data-doctor" && attribute.name !== "data-service" && attribute.name !== "data-tag"){
                    value = parseInt(attribute.value, 10);

                    if (Number.isNaN(value)) {
                        isValid = false;
                        break;
                    }
                }else{
                    value = attribute.value;
                }
                attributes[attributeNameSplited[1]] = value;
            }
        }

        if (isValid === true) {
            return attributes;
        } else {
            return null;
        }
    }

    static normalizeWidgetName(name) {
        if (~name.indexOf("-")) {
            return name.split("-").map((item) => (item.charAt(0).toUpperCase() + item.slice(1))).join("");
        } else {
            return name;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/utilites.js
 **/